import { useMutation, useQueryClient } from "@tanstack/react-query";
import { pathPickBasketMutationApi } from "@/features/pathpick/features/basket/api/mutation";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 네이버 제휴 연결 해제 — 바디 없이 호출한다.
// 성공 안내 UI는 호출부가 담당하고, 여기서는 연결 상태 조회만 무효화한다.
const useDisconnectNaverPartner = () => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: () =>
      pathPickBasketMutationApi.disconnectNaverPartner(companyId as number),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["pathpick", "naver-partner-status", companyId],
      });
      // 주소록은 무효화하지 않는다 — 이 시점의 연결 상태 캐시는 아직 연동 상태라
      // 무효화가 곧바로 재조회를 트리거한다(해제됐는데 주소록을 한 번 더 조회하게 된다).
      // 해제되면 주소록은 조회도 사용도 하지 않고, 다시 연동할 때
      // useConnectNaverPartner가 무효화하므로 이전 계정의 값이 쓰일 일도 없다.
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useDisconnectNaverPartner;
